import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.partClList = []; //유형(초도품, 초기양산, 양산, 변경품) selectBox
		state.ovrlJgmtList = []; //종합판정(합격/불합격/결품) selectBox
		state.pgsStPcList = []; //검사상태(검사중/검사완료/반려/작성/승인) selectBox
		state.useYnList = [];
		state.lotNoList = [];
		state.resultList = [];
		state.partCkuScrId = '';
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	}
};
